import { AbstractControl, FormArray, FormGroup } from '@angular/forms';

export function isControlInvalid(control: AbstractControl): boolean {
  if (control.invalid) {
    processAllControls(control);
    return true;
  }
  return false;
}

function processAllControls(control: AbstractControl) {
  if (control instanceof FormGroup || control instanceof FormArray) {
    Object.values(control.controls).forEach(processAllControls);
  } else if (!control.valid) {
    markControl(control);
  }
}

function markControl(control: AbstractControl) {
  control.updateValueAndValidity();
  control.markAsDirty();
  control.markAsTouched();
}
